export const SEARCH_DIALOG_WIDTH_OBSERVER_ID = 'quick-find-dialog';
